import React from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import MainHome from 'page/home';
import AboutArtectum from './components/views/about-artectum';
import AboutProductsArtectum from './components/views/about-products-artectum';
import Contact from './components/template/contact';
import ContactThanks from './components/template/contactThanks';
import Faq from './components/template/faq';
import Login from './components/views/login';

import AdminRoutes from 'page/admin/admin.routes';
import ProductRoutes from 'page/product/product.routes';
import PortfolioRoutes from 'page/portfolio/portfolio.routes';
import BlogRoutes from 'page/blog/blog.routes';

import Admin from 'page/admin/admin';
import Product from 'page/product/product';
import Portfolio from 'page/portfolio/portfolio';
import Blog from 'page/blog/blog';

const Routes = () => {

    return (
        <>
            <Switch>
                <Route exact path="/" component={MainHome} />
                <Route path="/about" component={AboutArtectum} />
                <Route path="/contact" component={Contact} />
                <Route path="/thanks" component={ContactThanks} />
                <Route path="/about-products" component={AboutProductsArtectum} />
                <Route path="/faq" component={Faq} />
                {/* <Route path="/catalog" component={Catalog} /> */}
                <Route path="/login" component={Login} />

                <Route path="/admin" component={Admin} />
                <Route path="/product" component={Product} />
                <Route path="/blog" component={Blog} />
                <Route path="/portfolio" component={Portfolio} />

                <Route exact path="/productos-de-concreto">
                    <Redirect to="/product/product-list" />
                </Route>
                <Route exact path="/contactenos">
                    <Redirect to="/contact" />
                </Route>
                <Route exact path="/quienes-somos">
                    <Redirect to="/about" />
                </Route>
                <Route exact path="/inicio3">
                    <Redirect to="/" />
                </Route>


                {/* Ruta comodín para no encontrados */}
                <Route path="*">
                    <Redirect to="/" />
                </Route>

                <AdminRoutes />
                <ProductRoutes />
                <PortfolioRoutes />
                <BlogRoutes />

                <Route path="/admin/*">
                    <Redirect to="/admin/content/home-banner-slide" />
                </Route>
                <Route path="/product/*">
                    <Redirect to="/product/product-list" />
                </Route>
                <Route path="/portfolio/*">
                    <Redirect to="/portfolio/portfolio-list" />
                </Route>
                <Route path="/blog/*">
                    <Redirect to="/" />
                </Route>

            </Switch>
        </>
    );
};

export default Routes;